import type { PropDefaults, PropElement, PropTypes } from "@platform/react-storybook/Component";
import type { UuidText } from "../../Element/Text/types";

import type { PropTypesCard } from "../Card/types";

import Namespace from "./_index.scss";

export const { NAME_SECTION_CARD_VERTICAL, TYPE_SECTION_CARD_VERTICAL } = Namespace;

export type PropVerticalCardsSection = PropElement & {
    /**  List of cards to render */
    cards: PropTypesCard[];
    /** If it has a title  */
    hasTitle?: boolean;
    /** A  `uuid` if provided, the corrresponding TITLE will be rendered */
    title?: UuidText;
};

export const DEF_SECTION_CARD_VERTICAL: PropDefaults<
    Omit<PropVerticalCardsSection, "hasTitle" | "title">
> = {};

export type PropTypesVerticalCardsSection = PropTypes<
    PropVerticalCardsSection,
    typeof DEF_SECTION_CARD_VERTICAL
>;
